import type { ComponentProps } from "react";
import { Alert, AlertTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CALENDAR_DATE = new Intl.DateTimeFormat("en-GB", { dateStyle: "long" });

/** Who returned a submission, when, and why, unframed: its caller gives it a title. */
export const ReturnDetails = ({
  reason,
  approverName,
  returnedAt,
}: {
  /** Why it came back; `null` where this reader may not read what it says. */
  reason: string | null;
  /** Who returned it; undefined where the involvements do not say. */
  approverName: string | undefined;
  returnedAt: Date;
}) => {
  const { t } = useTranslation();
  const date = CALENDAR_DATE.format(returnedAt);

  return (
    <>
      <Typography variant="body2">
        {approverName === undefined
          ? t("assessment.returned.on", { date })
          : t("assessment.returned.by", { approver: approverName, date })}
      </Typography>
      {reason === null ? null : (
        <Typography sx={{ mt: 1, whiteSpace: "pre-wrap" }}>{reason}</Typography>
      )}
    </>
  );
};

/** Why a submission was returned, kept in view on the assessment. */
export const ReturnedForChanges = (
  returned: ComponentProps<typeof ReturnDetails>,
) => {
  const { t } = useTranslation();

  return (
    <Alert severity="warning">
      <AlertTitle>{t("assessment.returned.title")}</AlertTitle>
      <ReturnDetails {...returned} />
    </Alert>
  );
};
